import React from 'react';
import { Pricing } from './Pricing';
export function Footer() {
  return <>
      <div className="bg-white py-10 md:py-12 text-center border-t border-gray-100" data-id="element-76">
        <div className="max-w-3xl mx-auto px-4" data-id="element-77">
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-charcoal mb-3 md:mb-4" data-id="element-78">
            NON LASCIARE PASSARE QUESTA OPPORTUNITÀ
          </h2>
          <p className="text-lg md:text-xl text-red-500 font-medium mb-6 md:mb-8" data-id="element-79">
            Il prezzo torna a €97 allo scadere del timer.
          </p>
        </div>
      </div>

      <Pricing data-id="element-80" />

      <footer className="bg-charcoal text-gray-400 py-10 md:py-12 border-t border-white/10" data-id="element-81">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-82">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-6 md:mb-8 pb-6 md:pb-8 border-b border-white/10" data-id="element-83">
            <div className="text-center md:text-left" data-id="element-84">
              <div className="inline-flex items-center justify-center md:justify-start text-white font-serif text-lg md:text-xl mb-3 md:mb-4 w-full md:w-auto" data-id="element-85">
                <span className="mr-2" data-id="element-86">🩰</span> BALLET PRONTO™
              </div>
              <p className="text-xs md:text-sm max-w-md mx-auto md:mx-0" data-id="element-87">
                Il sistema di insegnamento N°1 per insegnanti di ballet in
                Italia. Perché insegnare danza classica non dovrebbe costarti
                stress, improvvisazione e frustrazione costante.
              </p>
            </div>
            <div className="flex flex-col items-center md:items-end justify-center space-y-2 text-xs md:text-sm" data-id="element-88">
              <a href="#" className="hover:text-ballet-300 transition-colors" data-id="element-89">
                📩 fastlearnersofficial.com
              </a>
              <a href="#" className="hover:text-ballet-300 transition-colors" data-id="element-90">
                📱 @fastlearnersofficial
              </a>
              <a href="#" className="hover:text-ballet-300 transition-colors" data-id="element-91">
                🌐 fastlearnersofficial.com
              </a>
            </div>
          </div>
          <div className="text-center text-[10px] md:text-xs" data-id="element-92">
            <p data-id="element-93">© FastLearnersOfficial™ 2026 — Tutti i diritti riservati.</p>
          </div>
        </div>
      </footer>
    </>;
}